import classNames from 'classnames';
import React from 'react';
import { useIntercom } from '../../../../hooks/use_intercom';
import { RoutePaths } from '../../../../routes';
import { OmniaLink } from '../../../omnia_link/omnia_link';
import { SpanLink } from '../../../span_link/span_link';
import styles from './footer_card.less';
import callIcon from './icon_call.svg';
import chatIcon from './icon_chat.svg';
import faqIcon from './icon_faq.svg';

export const FooterCard = ({
  className,
  showFAQ = true,
}: {
  className?: string;
  showFAQ?: boolean;
}) => {
  const intercom = useIntercom();

  return (
    <section className={classNames(styles.footer, className)}>
      <div className={styles.footerCard}>
        <span>Need Help?</span>
        <div className={styles.footerIcons}>
          <SpanLink
            onClick={() => {
              intercom.show();
            }}
          >
            <img src={chatIcon} alt="chat-icon" /> Chat
          </SpanLink>
          <span>
            <a href="tel:+17637105581">
              <img src={callIcon} alt="call-icon" style={{ width: '22px' }} />
              Phone
            </a>
          </span>
          {showFAQ && (
            <span>
              <OmniaLink to={RoutePaths.PRO}>
                <img src={faqIcon} alt="faq-icon" />
                FAQ
              </OmniaLink>
            </span>
          )}
        </div>
      </div>
    </section>
  );
};
